import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/illustration.jpg")